import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import LdsButton from "../../components/LdsButton";
import { SideBar } from "../../components/SideBar";
import { useSelector } from "react-redux";

import { ReactLoaderSpinner } from "../../components/ReactLoaderSpinner/index.js";
import LdsImage from "../../components/LdsImage";
import References from "../../components/References";
import FigureCaption from "../../components/LdsFigureCaption";
import NegativeReliableLeft from "../../assets/module-1/Reliable_left-Enhanced-SR_1.png";
import NegativeReliableRight from "../../assets/module-1/Reliable_right-Enhanced-SR_1.png";

// services
import { useBookmarkModuleMutation } from "../../store/services/moduleServerApi";

const Module_1_2_2 = () => {
  const { pathname: pathName } = useLocation();
  const { menuItems } = useSelector((state) => state?.moduleSlice);

  const [bookmarkModule, { isLoading: isMenuLoading }] =
    useBookmarkModuleMutation();

  /* Start useEffect */
  useEffect(() => {
    bookmarkModule({ pathName });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // * onPageLoad
  /* End useEffect */

  return (
    <div className="row">
      {isMenuLoading && <ReactLoaderSpinner />}
      {menuItems?.id && <SideBar menuItems={[menuItems]} />}
      <div className="col-sm-8">
        <main>
          <section className="mb-5">
            <h1 className="blue text-uppercase b mt-5">
              1.2.2 Amyvid Is Reliable
            </h1>
            <p className="mt-1 mb-0">Estimated time to complete: 2 minutes</p>
          </section>
          <section className="mb-5 row">
            <p>
              Amyvid has been shown to be reliable for estimating β-amyloid
              neuritic plaque density.
              <br />
              <br />
            </p>
            <h2 className="h5 b">Amyvid and autopsy results agree*</h2>
            <p>
              Statistically significant correlation between Amyvid PET scan images and amyloid plaque deposition seen at autopsy (r=0.78; 95% CI: 0.58-0.89; <em>P</em>&lt;0.0001) (n=29).<sup>1</sup>
            </p>
            <div className="blue-square-border p-0 mt-4">
              <h2 className="p b pt-2 pb-2 blue-bg white text-center">Negative Amyvid PET Scan Pathology Results (Immunohistochemistry)</h2>
              <div className="row mt-4 mb-4">
                <div className="col-sm-12 col-md-8">
                  <FigureCaption
                    noCollapse={true}
                    className="figcaption-no-border align-items-center flex-column d-flex"
                    textContent={
                      <>
                        <p className="text-center">
                          &copy;2011. Avid Radiopharmaceuticals, Inc. All rights
                          reserved.Data on File, Lilly Research Laboratories:
                          AMY20120725.
                        </p>
                      </>
                    }
                  >
                    <LdsImage
                      src={NegativeReliableLeft}
                      alt="Negative Amyvid PET scan pathology results with a brain scan on the left and a microscopic image of tissue on the right. The text indicates low Amyvid uptake in cortical gray matter and no evidence of amyloid plaques."
                      style={{ maxWidth: "600px" }}
                      className=""
                    />
                  </FigureCaption>
                </div>
                <div className="col-sm-12 col-md-4">
                  <ul>
                    <li>Low Amyvid uptake in cortical gray matter.</li>
                    <li>No evidence of amyloid plaques.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="blue-square-border p-0">
              <h2 className="p b pt-2 pb-2 blue-bg white text-center">
                Positive Amyvid PET Scan Pathology Results
                (Immunohistochemistry)
              </h2>
              <div className="row mt-4 mb-4">
                <div className="col-sm-12 col-md-8">
                  <FigureCaption
                    noCollapse={true}
                    className="figcaption-no-border align-items-center flex-column d-flex"
                    textContent={
                      <>
                        <p className="text-center">
                          &copy;2011. Avid Radiopharmaceuticals, Inc. All rights
                          reserved.Data on File, Lilly Research Laboratories:
                          AMY20120725.
                        </p>
                      </>
                    }
                  >
                    <LdsImage
                      src={NegativeReliableRight}
                      alt="Positive Amyvid PET scan pathology results with a brain scan on the left and a microscopic image of tissue on the right. The text indicates high Amyvid uptake in cortical gray matter and high levels of amyloid plaques."
                      style={{ maxWidth: "600px" }}
                      className=""
                    />
                  </FigureCaption>
                </div>
                <div className="col-sm-12 col-md-4">
                  <ul>
                    <li>High Amyvid uptake in cortical gray matter.</li>
                    <li>High levels of amyloid plaques.</li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="blue-square-border p-0">
              <h2 className="p b pt-2 pb-2 blue-bg white text-center mb-0">
                Study 1: Assessed the correlation between amyloid plaques seen
                at autopsy and
                <br />
                estimates for amyloid plaque density using Amyvid PET imaging
              </h2>
            </div>
            <div className="light-blue-bg blue-square-border notop p-3">
              <p className="b fz-md">Design</p>
              <ul className="fz-md ms-0 ps-3">
                <li>3 readers</li>
                <li>
                  Semiquantitative reading methodology (not intended for
                  clinical use)
                </li>
              </ul>
            </div>
            <div className="light-blue-bg blue-square-border notop p-3">
              <p className="b fz-md">Population</p>
              <p className="fz-md">
                35 terminally ill patients who received premortem Amyvid scans
                and then underwent autopsy (29 of whom comprised the primary
                analysis set)
              </p>
            </div>
          </section>
          <section className="button-control mb-0">
            <LdsButton
              classes="white-button mt-3 mb-5 prev"
              onClick={function navClick() {
                window.open("/module-1/module-1-2-1", "_self");
              }}
            >
              Previous Lesson
            </LdsButton>
            <LdsButton
              classes="blue-button mt-3 mb-5 align-self-right float-end next"
              onClick={function navClick() {
                window.open("/module-1/module-1-2-3", "_self");
              }}
            >
              Next Lesson
            </LdsButton>
          </section>
          <section className="row mt-0 mb-5">
            <p className="fz-sm">
              *Patient scans and corresponding autopsy slides are from the same
              patient.
            </p>{" "}
          </section>
          <References>
            <ol className="no-indent fz-sm">
              <li>Amyvid (florbetapir F 18 injection) Prescribing Information. Lilly USA, LLC.</li>
              <li>Data on file, Lilly Research Laboratories: AMY20121001R.</li>
            </ol>
          </References>
        </main>
      </div>
    </div>
  );
};

export default Module_1_2_2;
